import React, { lazy, Suspense, useState, useEffect } from "react";
import useAuth from "../../hooks/useAuth";
import { useTranslation } from "react-i18next";
import ImageContent from "../dynamic/ImageContent";
import axios from "../../api/axios.js";
import { IconArrowRight } from "@tabler/icons-react";
import Content from "../dynamic/Content.jsx";
import FetchContent from "../dynamic/fetchContent.jsx";

const FetchImage = lazy(() => import("../dynamic/fetchImage"));
const WEBSITE_URL = "/dashboard/key";

const TourismOffice = ({ suggestionsUrl }) => {
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const { username, auth } = useAuth();
  const { t } = useTranslation();
  const [tourismOfficeLink, setTourismOfficeLink] = useState("");

  const buttonStyle = {
    padding: "10px 20px",
    fontSize: "16px",
    color: "#fff",
    backgroundColor: "var(--color-button)",
    border: "none",
    borderRadius: "5px",
    textDecoration: "none",
    display: "inline-block",
    textAlign: "center",
    cursor: "pointer",
    opacity: "80%",
  };

  useEffect(() => {
    function updateScreenSize() {
      setIsSmallScreen(window.innerWidth < 768);
    }
    window.addEventListener("resize", updateScreenSize);
    updateScreenSize();
    return () => window.removeEventListener("resize", updateScreenSize);
  }, []);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const res = await axios.get(WEBSITE_URL, {
          params: {
            username: username,
            key: "tourismOfficeLink",
          },
        });
        setTourismOfficeLink(res?.data?.tourismOfficeLink);
      } catch (error) {
        console.error(error);
      }
    };
    fetchContent();
  }, [username]);

  const renderButtons = () => {
    if (!tourismOfficeLink && !suggestionsUrl) return null;

    return (
      <div
        style={{
          display: "flex",
          gap: "10px",
          justifyContent: "center", 
          flexWrap: "wrap",
          marginBottom: "20px",
          padding: "0 15px",
        }}
      >
        {tourismOfficeLink && (
          <a
            href={tourismOfficeLink}
            target="_blank"
            rel="noreferrer"
            style={{
              ...buttonStyle,
              backgroundColor: "#f8f9fa",
              color: "var(--color-button)",
              border: "1px solid var(--color-button)",
            }}
          >
            {t("dashboard_page.acc_form.tourismOfficeLink")}
            <IconArrowRight size="20px" style={{ marginLeft: "8px" }} />
          </a>
        )}
        {suggestionsUrl && (
          <a
            href={suggestionsUrl}
            target="_blank"
            rel="noreferrer"
            style={buttonStyle}
          >
            {t("suggestions_page.recommendations")}
            <IconArrowRight size="20px" style={{ marginLeft: "8px" }} />
          </a>
        )}
      </div>
    );
  };

  return (
    <>
      {isSmallScreen ? (
        <div className="p dog-friendly-home">
          <div className="image-container">
            <Suspense fallback={<h1>Still Loading…</h1>}>
              {!auth?.role ? (
                <FetchImage
                  title="tourismOffice"
                  username={username}
                  type="image-features"
                />
              ) : (
                <ImageContent
                  title="tourismOffice"
                  username={username}
                  type="image-features"
                />
              )}
            </Suspense>
          </div>
          <div className="container">
            {renderButtons()}
            {!auth?.role ? (
              <div className="p">
                <FetchContent title="p-tourismOffice" />
              </div>
            ) : (
              <div className="p">
                <Content title={"p-tourismOffice"} styling="p" />
              </div>
            )}
          </div>
        </div>
      ) : (
        <>
          {renderButtons()}
          <div className="stripe container about-us-main">
            <div className="about-us-main-img" style={{ marginTop: "-50px" }}>
              {!auth?.role ? (
                <FetchImage
                  title="tourismOffice"
                  username={username}
                  type="about-us-main-img-container"
                />
              ) : (
                <ImageContent
                  title="tourismOffice"
                  username={username}
                  type="about-us-main-img-container"
                />
              )}
            </div>

            <div className="about-us-main-content">
              {!auth?.role ? (
                <div
                  className="p-brandnew"
                  style={{ textAlign: "justify", marginTop: "-50px" }}
                >
                  <FetchContent title="p-tourismOffice" />
                </div>
              ) : (
                <div className="p-brandnew">
                  <Content title={"p-tourismOffice"} styling="p" />
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default TourismOffice;
